$(document).ready(function(){
    $('.recent-posts-slider').slick({
        slidesToShow:3,
        slidesToScroll:1,
        arrows: false,
        dots:true,
        responsive: [
            {
                breakpoint:550,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })
})